import $$api from 'models/api';
import { CSSProperties, ChangeEvent, useState } from 'react';
import { Card, ListGroup, Spinner } from 'react-bootstrap';

import { Button } from 'components/StyledTemplates/StyledTemplates';

import DashboardService from 'services/DashboardService';

import useResources from 'hooks/useResources';

const DocumentListItemUpload = (props: any) => {
    const { t } = useResources();

    const [loading, setLoading] = useState<boolean>(false);

    const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
        setLoading(true);
        await DashboardService.uploadSignedDocument(props.document.document_id, event.target.files?.[0] as any);
        event.target.value = '';
        setLoading(false);
    };

    const onDownloadImageClick = async (filename: string) => {
        const document = props.document;
        await $$api.documents.downloadScanFx({ documentId: document.document_id, filename });
    };

    const onDeleteButtonClick = async (filename: string) => {
        try {
            const document = props.document;
            await $$api.documents.deleteScanFx({ id: document.document_id, filename });
            await DashboardService.updateDocumentsList();
            document.scan_names = document.scan_names.filter((name: any) => name !== filename);
        } catch (error) {
        } finally {
            props.forceUpdateParent();
        }
    };

    const scan_names = props.document.scan_names || [];
    const someFilesWereUploaded = scan_names.length > 0;
    const commonStyle: CSSProperties = {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
    };
    const fileNameStyle: CSSProperties = {
        textDecoration: 'underline',
        cursor: 'pointer',
    };
    return (
        <Card className="p-2 my-3">
            <div style={commonStyle}>
                <h6 className="ml-2 m-0 pr-2">{props.document.name}</h6>
                <label className="btn btn-dark px-5 mb-0 text-nowrap">
                    {loading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}{' '}
                    {t('EPCard.upload')}
                    <input
                        type="file"
                        hidden
                        onChange={handleFileChange}
                        accept="image/jpg, image/png, image/jpeg, application/pdf"
                    />
                </label>
            </div>
            {someFilesWereUploaded && (
                <>
                    <p className="ml-2 mt-3 mb-1">{t('EPCard.uploadedDocs')}</p>
                    <ListGroup className="mx-2" variant="flush">
                        {scan_names.map((name: any) => {
                            return (
                                <ListGroup.Item style={commonStyle} key={name}>
                                    <div style={fileNameStyle} onClick={async () => await onDownloadImageClick(name)}>
                                        {name}
                                    </div>
                                    <Button
                                        data-qaid="delete_button"
                                        size="sm"
                                        variant="danger"
                                        onClick={async () => await onDeleteButtonClick(name)}
                                    >
                                        {t('EPCard.delete')}
                                    </Button>
                                </ListGroup.Item>
                            );
                        })}
                    </ListGroup>
                </>
            )}
        </Card>
    );
};

export default DocumentListItemUpload;
